import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { setFormSubmitted } from 'store/Recruitment/actions'
import CreateJobInput from '../../CreateJob/CreateJobInput'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { createInterviewSchedule } from 'store/Recruitment/actions'
import moment from 'moment'
import { updateInterview } from 'store/Recruitment/actions'
import { setAllJobApplicationsAndJobs } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'

function CreateInterviewModal({
  showModal,
  setShowModal,
  interview = null,
  onSuccess = null,
}) {
  const location = useLocation()

  const dispatch = useDispatch()
  const { allApplications } = useSelector((store) => store.recruitment)
  const [admins, setAdmins] = useState([])
  const [selectedAdmins, setSelectedAdmins] = useState([])
  const [interviewDate, setInterviewDate] = useState(null)
  const [interviewTime, setInterviewTime] = useState(null)
  const [endInterviewTime, setEndInterviewTime] = useState(null)
  const [withAi, setWithAi] = useState(false)

  const [comment, setComment] = useState('')
  const [meetingInfo, setMeetingInfo] = useState('')
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false)

  const [manualApplication, setManualApplication] = useState(null)

  const dontKnowApplication =
    location?.pathname === '/job/interview-schedule' && !interview

  useEffect(() => {
    AxiosInstance.get(`/users/admins`).then((data) => {
      setAdmins(
        data?.map((el) => {
          return { name: `${el.first_name} ${el.last_name}`, id: el.id }
        })
      )
    })
  }, [])

  useEffect(() => {
    if (interview) {
      setSelectedAdmins(
        admins?.find((admin) => admin?.id === interview?.employee_id)
      )
      setInterviewDate(moment(interview?.date).format('YYYY-MM-DD'))
      setInterviewTime(interview.time)
      setComment(interview.comment)
      setMeetingInfo(interview.meeting_info)
      setWithAi(interview.with_ai)
    }
  }, [interview, admins])

  useEffect(() => {
    if (dontKnowApplication) {
      dispatch(setAllJobApplicationsAndJobs())
    }
  }, [dontKnowApplication, dispatch])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        {!interview ? 'Create Interview Schedule' : 'Edit Interview Schedule'}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <form
          id='interview'
          onSubmit={(e) => {
            e.preventDefault()

            dispatch(setFormSubmitted(true))

            const isValid = !withAi
              ? selectedAdmins && interviewDate && interviewTime
              : interviewDate

            if (!isValid) return

            const payload = {
              with_ai: withAi ? 1 : 0,
              application_id:
                manualApplication?.option?.id ??
                location?.search?.split('=')?.at(1),
              employee_id: selectedAdmins?.option?.id ?? selectedAdmins?.id,
              date: interviewDate,
              time: interviewTime,
              end_time: endInterviewTime,
              meeting_info: meetingInfo,
              comment,
            }

            if (!interview) {
              dispatch(createInterviewSchedule(payload))
            } else {
              const updateData = {
                ...payload,
                application_id: interview.application_id,
              }
              dispatch(updateInterview(interview.id, updateData))
            }

            if (onSuccess) {
              onSuccess()
            }

            setShowModal(false)
          }}
        >
          <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
            <div
              className='custom-control custom-checkbox mb-3 w-100'
              style={{ zIndex: '0' }}
            >
              <input
                className='custom-control-input'
                id={'with_ai'}
                name={'with_ai'}
                checked={withAi}
                type='checkbox'
                onChange={(e) => {
                  setWithAi(!withAi)
                }}
              />
              <label className='custom-control-label' htmlFor='with_ai'>
                AI-Conducted Interview
              </label>
            </div>
            {dontKnowApplication && (
              <CreateJobInput
                id='jobApplication'
                label='Job Application'
                placeholder='Select Application'
                required={true}
                fullSize={true}
                select={true}
                options={allApplications}
                selectedOptions={manualApplication}
                onChange={(val) => setManualApplication(val)}
              />
            )}
            {!withAi ? (
              <CreateJobInput
                id='joiningDate'
                label='Assign Employee'
                placeholder='Select Employee'
                required={true}
                fullSize={false}
                select={true}
                options={admins}
                selectedOptions={selectedAdmins}
                onChange={(val) => setSelectedAdmins(val)}
              />
            ) : null}

            <CreateJobInput
              id='interviewDate'
              label='Interview Date'
              fullSize={false}
              required={true}
              type='date'
              defaultValue={interviewDate}
              onChange={(val) => setInterviewDate(val)}
            />
            {!withAi ? (
              <>
                <CreateJobInput
                  id='interviewTime'
                  label='Start Time'
                  type='time'
                  required={true}
                  fullSize={false}
                  defaultValue={interviewTime}
                  onChange={(val) => setInterviewTime(val)}
                />
                <CreateJobInput
                  id='endInterviewTime'
                  label='End Time'
                  type='time'
                  required={true}
                  fullSize={false}
                  defaultValue={endInterviewTime}
                  onChange={(val) => setEndInterviewTime(val)}
                />
              </>
            ) : null}

            {/* <CreateJobInput
              id='interviewTime'
              label='Interview Time'
              type='text'
              required={true}
              fullSize={false}
              visibility='invisible'
              //   onChange={(val) => setSalary(val)}
            /> */}

            <CreateJobInput
              id='meetingInfo'
              placeholder={
                isTimePickerOpen ? '' : 'Enter meeting info (e.g: link)'
              }
              label='Meeting Info'
              fullSize={true}
              type='textarea'
              value={isTimePickerOpen ? '' : meetingInfo}
              onChange={(val) => setMeetingInfo(val)}
            />
            <CreateJobInput
              id='comment'
              placeholder={isTimePickerOpen ? '' : 'Enter Comment'}
              label='Comment'
              fullSize={true}
              type='textarea'
              value={isTimePickerOpen ? '' : comment}
              onChange={(val) => setComment(val)}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          text={!interview ? 'Create' : 'Update'}
          form='interview'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateInterviewModal
